var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var app;
(function (app) {
    var autenticacao;
    (function (autenticacao) {
        "use strict";
        var FormLogin = /** @class */ (function () {
            function FormLogin() {
            }
            return FormLogin;
        }());
        var LoginController = /** @class */ (function () {
            /** @ngInject **/
            function LoginController($state, $cookies, $window, messagesService, authService, versionService) {
                var _this = this;
                this.$state = $state;
                this.$cookies = $cookies;
                this.$window = $window;
                this.messagesService = messagesService;
                this.authService = authService;
                this.versionService = versionService;
                this.form = new FormLogin();
                Promise.all([this.versionService.getVersionUser(), this.versionService.getVersionServer()])
                    .then(function (_a) {
                    var versionUser = _a[0], versionServer = _a[1];
                    if (versionUser != versionServer) {
                        _this.$window.location.reload();
                    }
                });
                if (!this.isLocal() && (this.isMobile() || this.$window.location.hash)) {
                    this.authService.verifyRedirectAndAuthenticate()
                        .then(function (redirected) {
                        if (redirected) {
                            var originalUrlRequest = _this.$cookies.get("originalUrlRequest");
                            if (!!originalUrlRequest) {
                                _this.$cookies.remove("originalUrlRequest");
                                _this.$window.location.href = originalUrlRequest;
                            }
                            else {
                                return _this.$state.go("app.tarefas.minhas-tarefas");
                            }
                        }
                    });
                }
            }
            LoginController.prototype.isLocal = function () {
                return this.authService.isLocalAuthentication();
            };
            LoginController.prototype.entrar = function () {
                var _this = this;
                if (this.isLocal() || !this.isMobile()) {
                    return this.authService.authenticate(this.form.usuario, this.form.senha, true).then(function () {
                        var originalUrlRequest = _this.$cookies.get("originalUrlRequest");
                        if (!!originalUrlRequest) {
                            _this.$cookies.remove("originalUrlRequest");
                            _this.$window.location.href = originalUrlRequest;
                        }
                        else {
                            return _this.$state.go("app.tarefas.minhas-tarefas");
                        }
                    }).catch(function (erro) { return _this.tratarErro(erro); });
                }
                return this.authService.loginRedirect();
            };
            LoginController.prototype.tratarErro = function (error) {
                var msg;
                if (error.data && error.data.error_description) {
                    var parser = new DOMParser();
                    var dom = parser.parseFromString(error.data.error_description, "text/html");
                    msg = dom.body.textContent;
                }
                this.messagesService.error(msg ? msg : "Usuário ou senha inválido(s).");
            };
            LoginController.prototype.isMobile = function () {
                return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
                    navigator.maxTouchPoints > 0;
            };
            return LoginController;
        }());
        autenticacao.LoginController = LoginController;
        var LoginControllerDialog = /** @class */ (function (_super) {
            __extends(LoginControllerDialog, _super);
            /** @ngInject **/
            function LoginControllerDialog($state, $cookies, $window, messagesService, authService, versionService, $mdDialog, login) {
                var _this = _super.call(this, $state, $cookies, $window, messagesService, authService, versionService) || this;
                _this.$mdDialog = $mdDialog;
                _this.login = login;
                _this.form.usuario = login;
                return _this;
            }
            LoginControllerDialog.prototype.entrar = function () {
                var _this = this;
                return this.authService.authenticate(this.form.usuario, this.form.senha).then(function () {
                    _this.$mdDialog.hide();
                    _this.messagesService.success("Autenticação realizada com sucesso!");
                    if (_this.form.usuario != _this.login) {
                        _this.$window.location.reload(false);
                    }
                }).catch(function (erro) { return _this.tratarErro(erro); });
            };
            LoginControllerDialog.prototype.fechar = function () {
                this.$mdDialog.cancel();
            };
            return LoginControllerDialog;
        }(LoginController));
        autenticacao.LoginControllerDialog = LoginControllerDialog;
        angular.module("app.login")
            .controller("app.login.LoginController", LoginController)
            .controller("app.login.LoginControllerDialog", LoginControllerDialog);
    })(autenticacao = app.autenticacao || (app.autenticacao = {}));
})(app || (app = {}));
